import type { SpikeItem } from '../components/types';

export function transPropsCardData(listData: Array<any> | undefined): SpikeItem[] {
    if (!listData) {
        return [];
    }

    return listData
        .filter((item) => item.itemId)
        .map((cardItem) => {
            return {
                itemId: cardItem.itemId!,
                itemBanner: cardItem.itemBanner!,
                itemTitle: cardItem.itemTitle!,
                itemImgUrl: cardItem.itemImgUrl!,
                tags: cardItem.tags!,
                soldStock: cardItem.soldStock!,
                itemMarketPrice: cardItem.itemMarketPrice!,
                discountPrice: cardItem.discountPrice!,
                discount: cardItem.discount!,
                itemOrderUrlKrn: cardItem.itemOrderUrlKrn!,
                brandName: cardItem.brandName!,
                priceGap: cardItem.priceGap!,
                itemDetailUrl: cardItem.itemDetailUrl!,
            };
        });
}
